// Phase 36 Batch AQ — PostHog event helpers for the Comps tab.
//
// All wrapped in try/catch so blocked / unloaded PostHog never breaks
// the page.

function _capture(name, props = {}) {
  try {
    if (typeof window === "undefined") return;
    window.posthog?.capture?.(name, props);
  } catch {
    /* PostHog blocked or not loaded — ignore */
  }
}

export function trackCompsTabViewed({ deal_id, comp_count, confidence }) {
  _capture("comps_tab_viewed", { deal_id, comp_count, confidence });
}

export function trackCompsFilterChanged({ deal_id, filter_type, new_value }) {
  _capture("comps_filter_changed", { deal_id, filter_type, new_value });
}

export function trackCompClicked({ deal_id, comp_id, distance }) {
  _capture("comp_clicked", { deal_id, comp_id, distance });
}
